import WizardJugadoresView from './views/WizardJugadoresView.vue'
import WizardPersonalView from './views/WizardPersonalView .vue'

export default [
  {
    path: '/wizard-jugadores-duplicados',
    name: 'wizard-jug-dup',
    component: WizardJugadoresView
  },
  {
    path: '/wizard-cuerpo-tecnico-duplicados',
    name: 'wizard-tec-dup',
    component: WizardPersonalView
  }
]
